var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./PerspectiveArchivesListInner.jinja');
require('./PerspectiveArchivesListInner.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArchivesList/PerspectiveArchivesListInner.js
// module id = 233
// module chunks = 0